import { render, staticRenderFns } from "./NotificationData.vue?vue&type=template&id=e8b8f8f8&scoped=true&"
import script from "./NotificationData.ts?vue&type=script&lang=ts&"
export * from "./NotificationData.ts?vue&type=script&lang=ts&"
import style0 from "../ListNotification.scss?vue&type=style&index=0&id=e8b8f8f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b8f8f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
